import type { RecurringPayment, RecurringPaymentConfirmation, RecurringPaymentPayload } from "../types";
import { api } from "./core";

export const recurringPaymentsApi = {
  recurringPayments: (groupId: string) => api<RecurringPayment[]>("/recurring-payments", { groupId }),
  createRecurringPayment: (groupId: string, payload: RecurringPaymentPayload) =>
    api<RecurringPayment>("/recurring-payments", { method: "POST", body: JSON.stringify(payload), groupId }),
  updateRecurringPayment: (groupId: string, id: string, payload: RecurringPaymentPayload) =>
    api<RecurringPayment>(`/recurring-payments/${id}`, { method: "PATCH", body: JSON.stringify(payload), groupId }),
  deleteRecurringPayment: (groupId: string, id: string) =>
    api<void>(`/recurring-payments/${id}`, { method: "DELETE", groupId }),
  restoreRecurringPayment: (groupId: string, id: string) =>
    api<RecurringPayment>(`/recurring-payments/${id}/restore`, { method: "POST", groupId }),
  pauseRecurringPayment: (groupId: string, id: string) =>
    api<RecurringPayment>(`/recurring-payments/${id}/pause`, { method: "POST", groupId }),
  resumeRecurringPayment: (groupId: string, id: string) =>
    api<RecurringPayment>(`/recurring-payments/${id}/resume`, { method: "POST", groupId }),
  confirmRecurringPayment: (groupId: string, id: string, payload?: { occurred_on?: string; amount?: string }) =>
    api<RecurringPaymentConfirmation>(`/recurring-payments/${id}/confirm`, { method: "POST", body: payload ? JSON.stringify(payload) : undefined, groupId }),
  skipRecurringPayment: (groupId: string, id: string) =>
    api<RecurringPayment>(`/recurring-payments/${id}/skip`, { method: "POST", groupId }),
};
